import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const nuxtApp = useNuxtApp();
  if (!nuxtApp.$pinia) {
    return;
  }
  const { setLoader } = useDialogStore();

  if (to.path !== from.path) {
    setLoader(false);
  }
});
